import Poool from './Poool.js';

if (document.documentElement.lang !== 'en-UK') {
  new Poool('Ux3eWdmyaRN4vgVq60rsLRVZu0KCWfNGTVyZ0B74H7CQwkQOekXVg43zcoYyd8YM', 'Maddyness');
}
